import { useEffect, useState } from 'react'

import { selectContractorByUuid } from '../payroll.selectors'
import { fetchAllContractorForms } from '../payrollActions'
import { GustoFormsTable } from '../payroll-documents/GustoFormsTable'
import { Text } from '@/ui'
import { useReselector } from '@/utils/sharedHooks'
import { getContractorName } from '../helpers'
import { useAppDispatch } from '@/utils/typeHelpers'
import { Gusto_GustoForm } from '../generated_gusto_types'
import { TypographyStyles } from '@/styles'

export const ContractorDocumentsTab = ({ uuid }: { uuid: string }) => {
  const dispatch = useAppDispatch()
  const contractor = useReselector(selectContractorByUuid, uuid)

  const [forms, setForms] = useState<Gusto_GustoForm[]>([])

  useEffect(() => {
    const fetchForms = async () => {
      const res = await fetchAllContractorForms(uuid)(dispatch)
      if (res) {
        setForms(res)
      }
    }

    fetchForms()
  }, [dispatch, uuid])

  if (!contractor) {
    return null
  }

  return (
    <div className="flex flex-col gap-6">
      <br />
      <Text variant={TypographyStyles.H2}>Contractor Documents</Text>

      <Text>
        These are documents shared between you and{' '}
        <b>{getContractorName(contractor)}</b>
      </Text>
      <GustoFormsTable forms={forms} contractorUuid={uuid} allowSign={false} />
    </div>
  )
}
